function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Group 4");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Screens",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-4",
  fill: "#000000",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  x: 62.6029412,
  y: 2.90126582,
  width: 6.26470588,
  height: 6.07594937
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  points: "64.2941176 12 54.1323529 6.06075949 64.2647059 0"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  x: -2.93098879e-14,
  y: 3.08148148,
  width: 5.964,
  height: 5.92592593
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  points: "4.326 0.133333333 14 6.04444444 4.326 11.9555556"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-Copy",
  x: 13,
  y: 6,
  width: 1,
  height: 26
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  x: 59.0666667,
  y: 43,
  width: 5.92592593,
  height: 5.964
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  points: "67.9259259 47.326 62.0296296 57 56.1333333 47.326"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-Copy-6",
  x: 39,
  y: 56,
  width: 24,
  height: 1
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  x: 59.0666667,
  y: 68.970297,
  width: 5.92592593,
  height: 5.9049505
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  points: "56.1333333 70.5920792 62.0296296 61.0277228 67.9259259 70.5920792"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22,32 L26,32 C26,27.5857143 29.5857143,24 34,24 L34,20 C27.3857143,20 22,25.3857143 22,32 Z",
  id: "Path-Copy"
}), /*#__PURE__*/React.createElement("path", {
  d: "M30.574399,56.9860077 L30.574399,56.9860077 C30.574399,56.3843406 30.4905783,55.8106579 30.3089669,55.2509675 C29.6244314,53.0681751 27.5149448,47.3313486 22.7092268,41.8323906 C20.1946069,38.9639774 18.8534763,35.3259899 18.8534763,31.5340875 C18.8255361,22.5230723 26.1458739,15.8627568 34.4860299,15.8627568 C43.105588,15.8627568 50.1325536,22.8868711 50.1325536,31.5340875 C50.1325536,35.3259899 48.7634828,38.9779696 46.262833,41.8323906 C41.4850552,47.2893718 39.3755686,53.0261983 38.677063,55.222983 C38.4954516,55.7826734 38.4116309,56.3843406 38.4116309,56.9720155 L38.4116309,56.9860077 L44.2790773,56.9860077 L44.2790773,56.9860077 C45.4665367,52.9002679 48.6517219,48.0309616 50.6773879,45.7082465 C53.9883041,41.9163442 56,36.9630843 56,31.5340875 C56,19.6406669 46.3745939,10 34.5,10 C21.9967511,10 13,20.1583805 13,31.5340875 C13,36.9630843 15.0116959,41.9163442 18.3226121,45.7082465 C20.3622482,48.0309616 23.5474334,52.9002679 24.7209227,56.9860077 L24.7209227,57 L30.574399,57 L30.574399,56.9860077 Z",
  id: "Path-Copy-2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M62,60 L25,60 L25,65.4064362 C25,65.806913 25.1105302,66.1787843 25.3177745,66.5077473 L28.2744586,71.11323 C28.6336819,71.6710369 29.2415982,72 29.8771471,72 L39.4103809,72 C40.0597461,72 40.6676624,71.6710369 41.0130695,71.11323 L43.9697535,66.5077473 C44.1769978,66.1787843 44.287528,65.7926103 44.287528,65.4064362 L44.287528,61.4302741 L61.9585512,61.4302741 L61.9585512,60 L62,60 Z",
  id: "Path-Copy-3"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-Copy-7",
  x: 55,
  y: 6,
  width: 1,
  height: 26
})));

var SvgAnalyzingIdeation = function SvgAnalyzingIdeation(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "69px",
    height: "75px",
    viewBox: "0 0 69 75",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAnalyzingIdeation, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Analyzing-Ideation.0e60d3b7.svg";
export { ForwardRef as ReactComponent };